function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M21.475 4.701L1.573 39.147c-3.612 6.267-.796 11.448 6.34 11.448H48.34c7.132 0 9.952-5.18 6.34-11.448L34.686 4.7C32.88 1.566 30.481 0 28.081 0c-2.4 0-4.802 1.566-6.606 4.701z",
  id: "a"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(1.875 5)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  fill: "#FFD00D",
  mask: "url(#b)",
  d: "M-10.045 60.714h76.34v-70.833h-76.34z"
}), React.createElement("path", {
  d: "M24.47 39.418c0-2.09 1.584-3.726 3.61-3.726s3.701 1.726 3.613 3.726c0 2.09-1.587 3.726-3.612 3.726-2.027 0-3.61-1.636-3.61-3.726zM29.188 32.65h-2.26c-1.146 0-2.084-.998-2.084-2.219V15.444c0-1.223.938-2.222 2.084-2.222h2.26c1.148 0 2.084 1 2.084 2.222v14.987c0 1.22-.936 2.22-2.084 2.22",
  fill: "#FFF",
  mask: "url(#b)"
})));

var SvgIconAlert = function SvgIconAlert(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgIconAlert;